/**
 * Single source of truth for the supported-locales list. Mirrors the values
 * of the Prisma `Locale` enum (which lives in apps/backend's schema). When a
 * new locale is added the only places that need editing are: the Prisma
 * enum, this file, and the JSON translation files in
 * apps/outlook-addin/src/config/i18n/.
 */
export const SUPPORTED_LOCALE_TAGS = ['en-GB', 'en-IN', 'en-US', 'ja'];
/**
 * String-literal mirror of the Prisma `Locale` enum values. Kept in sync with
 * the schema by convention — both lists derive from `SUPPORTED_LOCALE_TAGS`
 * via the maps below.
 */
export const LOCALE_ENUMS = ['EN_GB', 'EN_IN', 'EN_US', 'JA'];
export const DEFAULT_LOCALE_TAG = 'en-GB';
export const DEFAULT_LOCALE_ENUM = 'EN_GB';
export const LOCALE_TAG_LABELS = {
    'en-GB': 'English (UK)',
    'en-IN': 'English (India)',
    'en-US': 'English (US)',
    ja: 'Japanese',
};
const ENUM_TO_TAG = {
    EN_GB: 'en-GB',
    EN_IN: 'en-IN',
    EN_US: 'en-US',
    JA: 'ja',
};
const TAG_TO_ENUM = {
    'en-GB': 'EN_GB',
    'en-IN': 'EN_IN',
    'en-US': 'EN_US',
    ja: 'JA',
};
export function localeEnumToTag(locale) {
    return ENUM_TO_TAG[locale];
}
export function tagToLocaleEnum(tag) {
    return Object.hasOwn(TAG_TO_ENUM, tag) ? TAG_TO_ENUM[tag] : null;
}
export function isSupportedTag(tag) {
    return !!tag && SUPPORTED_LOCALE_TAGS.includes(tag);
}
/**
 * The order users see in the Profile dropdown and the first-run gate. Order
 * matters here because it's user-visible; do not sort `LOCALE_TAG_LABELS`
 * alphabetically in this list.
 */
export const LANGUAGE_OPTIONS = [
    { label: 'English (India)', value: 'en-IN' },
    { label: 'English (US)', value: 'en-US' },
    { label: 'English (UK)', value: 'en-GB' },
    { label: 'Japanese', value: 'ja' },
];
//# sourceMappingURL=index.js.map